export const isEmptyString = (text: string): boolean =>  (!text || text.length === 0 )